import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useEffect } from "react";

const useRedirectToCheckout = () => {
  const history = useHistory();
  const pricingStatus = useSelector((state) => state.pricing.uiState);
  useEffect(() => {
    if (pricingStatus === "checkout") {
      history.push("/pricing");
    }
  }, []);
};
export default useRedirectToCheckout;
